import { useQuery } from '@tanstack/react-query';
import { getServiceCatalog, getPlatformServices, getServiceCategories } from '../services/platform/platformServiceService';

export function useServiceCatalog() {
  return useQuery({
    queryKey: ['service-catalog'],
    queryFn: getServiceCatalog,
    staleTime: 5 * 60 * 1000,
  });
}

export function usePlatformServices() {
  return useQuery({
    queryKey: ['platform-services'],
    queryFn: () => getPlatformServices({ status: 'active' }),
    staleTime: 5 * 60 * 1000,
  });
}

export function useServiceCategories() {
  return useQuery({
    queryKey: ['service-categories'],
    queryFn: getServiceCategories,
    staleTime: 10 * 60 * 1000,
  });
}
